import { EventRepository } from '../../internal/repositories/EventRepository';
import serviceNames from '../../service-setup/AnalyticsService';
import { diContainer } from '../../service-setup/diContainer';
import { Event } from '../domain/entities/Event';
import { events } from '@estee/elc-service-bus';

export interface ISearchFiltersSelected {
    facetId: string;
    responseId?: string;
    filterCategory?: string;
    filterLabel?: string;
}

export class SearchFiltersSelectedUsecase {
    private eventRepository: EventRepository;
    private facetId: string;
    private responseId: string;
    private filterCategory: string;
    private filterLabel: string;

    constructor(payload: ISearchFiltersSelected) {
        this.eventRepository = diContainer.get(serviceNames.eventRepository);
        this.facetId = payload.facetId;
        this.responseId = payload.responseId || '';
        this.filterCategory = payload.filterCategory || '';
        this.filterLabel = payload.filterLabel || '';
    }

    public execute = async () => {
        const searchFilterPayload = {
            event_name: 'attraqt_facet',
            event_category: 'filter & sort selection',
            event_action: `facet - ${this.filterCategory} | ${this.filterLabel}`,
            event_label: 'add',
            vendor: 'attraqt',
            attraqt_facet_id: this.facetId,
            attraqt_responseId: this.responseId,
            attraqt_facet_name: this.filterLabel
        };

        const newEvent = new Event({
            id: this.eventRepository.generateId(),
            name: events.SEARCH_FILTERS_SELECTED,
            type: 'link',
            payload: searchFilterPayload
        });
        this.eventRepository.addEventToQueue(newEvent);
    };
}
